export enum SaveButtonVisibility {
  Hidden = 10,
  Visible = 20,
  OnlyCreate = 30,
  OnlySave = 40,
}
